import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Modal = ({ open, title, onClose, children, width }) => {
    if (!open) {
        return null;
    }
    return (_jsx("div", { className: "modal-backdrop", children: _jsxs("div", { className: "modal", style: width ? { width } : undefined, children: [_jsxs("div", { className: "modal__header", children: [title && _jsx("h2", { children: title }), onClose && (_jsx("button", { className: "modal__close", type: "button", onClick: onClose, children: "\u00D7" }))] }), _jsx("div", { className: "modal__content", children: children })] }) }));
};
export default Modal;
